import apiService from "services/api";
import { useNotificationContext } from "contexts";
import { useForm } from "react-hook-form";
import { FormGroup, Label, Button } from "reactstrap";
import { Link, useParams, useHistory } from "react-router-dom";
import { capitalize } from "utils/capitalize";
import { titleCase } from "utils/titleCase";
import { useQuery } from "react-query";
import { permissionCategories, permissionActions } from "./constants";
import { centres, centreOptions } from "constants";

const EditRolePage = () => {
	const { role_id } = useParams();
	const history = useHistory();
	const {
		data: role,
		isLoading,
		refetch,
	} = useQuery(["role", role_id], () => apiService.role.get(role_id).then(formatDBInput), {
		refetchOnwindowFocus: false,
		onSuccess: (data) => {
			reset(data);
		},
	});

	const { register, reset, handleSubmit } = useForm();

	const { createNotification } = useNotificationContext();

	const parseFormInput = (tempFormBody) => {
		var formBody = {};
		Object.keys(tempFormBody).forEach((key) => {
			if (key === "name") return (formBody.name = tempFormBody.name);
			if (key === "centre")
				return (formBody[key] = Object.keys(tempFormBody[key])
					.filter((action) => tempFormBody[key][action])
					.join(":"));
			formBody[key] = Object.keys(tempFormBody[key])
				.map((action) => (tempFormBody[key][action] ? action : ""))
				.join("");
		});
		return formBody;
	};

	const formatDBInput = (dbInput) => {
		var formBody = {};
		Object.keys(dbInput).forEach((key) => {
			if (key === "id" || key === "name") return (formBody[key] = dbInput[key]);
			if (key === "centre") return (formBody.centre = Object.fromEntries(centres.map((centre) => [centre, dbInput.centre.includes(centre)])));
			const permissions = dbInput[key];
			formBody[key] = Object.fromEntries(
				permissionActions.map(([_, permissionValue]) => [permissionValue, permissions.includes(permissionValue)])
			);
		});
		return formBody;
	};

	const submitEditRoleForm = async (data) => {
		const formBody = parseFormInput(data);
		apiService.role
			.update(role_id, formBody)
			.then(() => {
				createNotification({
					type: "success",
					message: "Successfully updated role",
				});
				history.push("/role");
			})
			.catch((error) =>
				createNotification({
					type: "danger",
					message: `Failed to create a new role: ${error.message}`,
				})
			);
	};

	const PermissionOptions = ({ name }) => (
		<div className="row ml-2 mb-4">
			<div className="col-12 col-sm-3 mt-2 text-light">{name.split("_").map(capitalize).join(" ")} : </div>

			<div className="col-12 col-sm-9 d-flex flex-wrap">
				{permissionActions.map(([label, value], index) => (
					<div className="mr-2 border border-primary d-flex align-items-center rounded form-check px-2 py-1" key={index}>
						<label className="form-check-label">
							<input className="form-check-input" type="checkbox" {...register(`${name}.${value}`)} />
							<span className="form-check-sign"></span>
							<small className="text-primary">{titleCase(label)}</small>
						</label>
					</div>
				))}
			</div>
		</div>
	);

	return (
		<form onSubmit={handleSubmit(submitEditRoleForm)} className="content">
			<h5 className="text-center mb-4">Edit Role</h5>

			<div className="d-flex justify-content-center">
				<div className="w-75">
					<div className="mb-5">
						<Link to="/role" className="btn btn-sm btn-info">
							&lt; Back to roles
						</Link>
					</div>
					<div className="mb-3">
						<FormGroup className="mb-1">
							<Label for="Title" className="text-white">
								Name
							</Label>
						</FormGroup>
						<input type="text" className="form-control" placeholder="Role Name" {...register("name")} />
					</div>
					<div className="mb-3">
						<FormGroup className="mb-1">
							<Label for="Description" className="text-white">
								Permissions
							</Label>
						</FormGroup>
						{permissionCategories.map((permission, key) => (
							<PermissionOptions key={key} name={permission} />
						))}
					</div>
					<div className="row ml-2 mb-4">
						<div className="col-12 col-sm-3 mt-2 text-light">Centre:</div>
						<div className="col-12 col-sm-9 d-flex flex-wrap">
							{centreOptions.map(({ label, value }, index) => (
								<div className="mr-2 border border-primary rounded px-2 py-1 form-check" key={index}>
									<label className="form-check-label">
										<input className="form-check-input" type="checkbox" {...register(`centre.${value}`)} />
										<span className="form-check-sign"></span>
										<small className="text-primary">{titleCase(label)}</small>
									</label>
								</div>
							))}
						</div>
					</div>
					<div className="d-flex justify-content-end mt-5">
						{isLoading ? (
							<Button color="primary" disabled={true}>
								<span className="spinner-border"></span>
							</Button>
						) : (
							<Button color="primary" type="submit">
								Submit
							</Button>
						)}
						<button className="btn btn-secondary" type="reset" onClick={refetch}>
							Reset
						</button>
					</div>
				</div>
			</div>
		</form>
	);
};

export default EditRolePage;
